import trace from './trace.mjs';

const matchHeightsForElement = (parent, attribute) => {

    const selectors = parent
        .getAttribute( attribute )
        .split(',')
        .map( selector => selector.trim() )
    ;

    trace.log( 'Match height: found match-height definition:', selectors );

    selectors.forEach( selector => {
        let children   = parent.querySelectorAll( selector );
        let lastOffset = null;
        let groups     = [];
        let group      = [];

        if( ! children.length ) {
            trace.log( 'Match height: no children for selector:', selector );
            return;
        }

        trace.log( 'Match height: processing children for selector:', selector );

        children.forEach( child => {
            if( lastOffset !== null && Math.abs(child.offsetTop - lastOffset) > 5 ) {
                groups.push( group );
                group = [];
            }

            lastOffset = child.offsetTop;
            group.push( child );
        });

        if( group.length ) {
            groups.push( group );
        }

        trace.log( 'Match height: selector groups', selector, groups );

        groups.forEach( (group, index) => {
            // Reset any existing style information.
            group.map( e => e.style.height = null );

            let maxHeight = group.reduce( (h,e) => Math.max(h,e.offsetHeight), 0 );
            trace.log( 'Match height: selector group max-height', selector, index, maxHeight );

            group.map( e => e.style.height = maxHeight + 'px' );
        });
    });
};

const matchHeights = attribute => {
    let selector = `[${attribute}]`;

    document
        .querySelectorAll( selector )
        .forEach( element => {
            matchHeightsForElement( element, attribute );

            let loadingElements = element.querySelectorAll('[data-changes-dimensions]');
            loadingElements.forEach( el => el.addEventListener( 'load', () => {
                matchHeightsForElement( element, attribute );
            }));
        })
    ;
};

const dimensionRelatedOperations = () => {
    matchHeights('data-match-height');
};

document.addEventListener( 'DOMContentLoaded', (event) => {
    trace.info('Match height: DOM Content Loaded');
    dimensionRelatedOperations();
});

window.addEventListener( 'resize', (event) => {
    trace.info('Match height: resize triggered');
    dimensionRelatedOperations();
});

// Get notified in supported browsers when fonts have loaded...
/** @see https://stackoverflow.com/a/32292880 */
document?.fonts?.ready?.then( () => {
    trace.info('Match height: fonts loaded promise resolved');
    dimensionRelatedOperations();
})

export const callManualUpdate = function() {
    trace.log('Match height: Manual update called');
    // Call after a tick, allow for Vue to update.
    setTimeout( () => dimensionRelatedOperations(), 10 );
    return true;
};
